import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CONTACT_US_ROUTE } from 'data/global';

import './GenericErrorContent.styles.scss';

type GenericErrorContentProps = {
  className?: string;
};

const GenericErrorContent: React.FC<GenericErrorContentProps> = (props) => {
  const { className } = props;

  const classes = classNames('generic-error-content', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <p>
        <span>{t('genericErrorPart1')}</span>
        <Link to={CONTACT_US_ROUTE}>{t('contactUs')}</Link>
        <span>{t('genericErrorPart2')}</span>
      </p>
      <Link
        to={CONTACT_US_ROUTE}
        className="ncoded-button ncoded-button--outline"
      >
        {t('contactResolve')}
      </Link>
    </div>
  );
};

export default GenericErrorContent;
